export function zero(buf){
	for(var i = 0; i < buf.length; i++){
		buf[i] = 0;
	}
};
